(() => {
  if (window.kslRevealInitialized) return;
  window.kslRevealInitialized = true;
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const targets = '.ksl-section__heading, .ksl-editorial__media, .ksl-editorial__content, .ksl-card-grid__item, .ksl-section .product-grid > li, .ksl-faq__item';
  const tracked = new Set();
  const imageTracked = new Map();
  let observer;
  let imageObserver;
  const showImage = image => {
    const state = imageTracked.get(image);
    if (state) {
      clearTimeout(state.timer);
      image.removeEventListener('load', state.ready);
      image.removeEventListener('error', state.error);
    }
    image.classList.remove('ksl-image-pending');
    imageObserver?.unobserve(image);
    imageTracked.delete(image);
  };
  const show = element => {
    element.classList.remove('ksl-reveal-pending');
    observer?.unobserve(element);
    tracked.delete(element);
  };
  const showAll = () => {
    observer?.disconnect();
    [...tracked].forEach(show);
    imageObserver?.disconnect();
    [...imageTracked.keys()].forEach(showImage);
  };
  function scan(root = document) {
    if (window.Shopify?.designMode || preference.matches || !window.IntersectionObserver) return;
    observer ??= new IntersectionObserver(entries => {
      entries.forEach(entry => { if (entry.isIntersecting) show(entry.target); });
    }, { threshold: 0, rootMargin: '0px 0px -24px 0px' });
    root.querySelectorAll(targets).forEach(element => {
      if (element.dataset.kslRevealSeen) return;
      element.dataset.kslRevealSeen = 'true';
      element.classList.add('ksl-reveal');
      // First-screen content and short viewports never wait for an observer.
      if (element.getBoundingClientRect().top < innerHeight - 24) return;
      const siblings = [...element.parentElement.children];
      element.style.setProperty('--ksl-reveal-delay', `${Math.min(siblings.indexOf(element), 3) * 45}ms`);
      element.classList.add('ksl-reveal-pending');
      tracked.add(element);
      observer.observe(element);
    });
    imageObserver ??= new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const image = entry.target;
        const state = imageTracked.get(image);
        if (!state) return;
        state.entered = true;
        if (image.complete) showImage(image);
        else state.timer ??= setTimeout(() => showImage(image), 2500);
      });
    }, { threshold: 0, rootMargin: '0px 0px -24px 0px' });
    root.querySelectorAll('.ksl-editorial__media img, .ksl-card__media img, .ksl-section .card__media img:first-child').forEach(image => {
      if (image.dataset.kslImageSeen) return;
      image.dataset.kslImageSeen = 'true';
      // The first screen, including the hero, is always immediately visible.
      if (image.getBoundingClientRect().top < innerHeight - 24) return;
      const state = { entered: false, timer: null };
      state.ready = () => { if (state.entered) showImage(image); };
      state.error = () => showImage(image);
      imageTracked.set(image, state);
      image.classList.add('ksl-image-reveal', 'ksl-image-pending');
      image.addEventListener('load', state.ready);
      image.addEventListener('error', state.error);
      imageObserver.observe(image);
    });
  }
  document.addEventListener('focusin', event => {
    const element = event.target.closest('.ksl-reveal-pending');
    if (element) show(element);
    event.target.closest('.ksl-card-grid__item, .product-grid > li, .ksl-editorial__layout')?.querySelectorAll('.ksl-image-pending').forEach(showImage);
  });
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    [...tracked].filter(element => event.target.contains(element)).forEach(show);
    [...imageTracked.keys()].filter(image => event.target.contains(image)).forEach(showImage);
  });
  preference.addEventListener('change', () => { if (preference.matches) showAll(); else scan(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  else scan();
})();
